// eslint-disable-next-line import/no-unused-modules
module.exports = () => ([
  { appAddress: '0x123', icon: function() {return null}, name: 'Kernel' },
  { appAddress: '0xbaB65A7D8a8F67D38cD26af113b95279fA3E7616', icon: function() {return null}, name: 'Voting' },
  { appAddress: '0x978f4De6B4833e956a366A441B277deB7A7C0d4c', icon: function() {return null}, name: 'Voting' },
])
